import React, {Component} from 'react';
import { Formik, Form, Field } from 'formik';
import {
    Grid,
    Button,
    Message, Input, Header, Icon
} from 'semantic-ui-react';

import FormsInputsEmail from '../../inputs/email/forms_inputs_email';
import FormsInputsText from '../../inputs/text/forms_inputs_text';
import FormsInputsNumber from '../../inputs/number/forms_inputs_number';
import UpdateEmailSchema from './validation';
import UpdateProfileSchema from '../../profile/update_profile/validation';

class FormsUpdateEmail extends Component {
    state = {
        inVerifyOTPState: false,
        error: false,
        errorMessage: null,
        success: false,
        newEmailConfirm: '',
        currentEmail: this.props.user.email,
        isVerifyPassword: false,
        showPassword: false
    }

    renderVerifyOTPForm() {
        if (this.state.success === true) {
            return (
                <Grid.Column>
                    <Field
                        name="otp"
                        label="OTP"
                        component={FormsInputsText}
                        secondaryLabel=""
                    />
                </Grid.Column>
            );
        }
    }

    renderFormSubmissionResult() {
        if (this.state.error === true) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there was an issue with the change</Message.Header>
                    <p>
                        { this.state.errorMessage }
                    </p>
                </Message>
            );
        }

        if (this.state.success === true) {
            return (
                <Message positive>
                    <Message.Header>Your email is successfully changed!</Message.Header>
                </Message>
            );
        }
    }

    render() {
        console.log('newEmailConfirm-', this.state.newEmailConfirm);
        return (
            <div>
                {
                    !this.state.inVerifyOTPState && !this.state.isVerifyPassword
                    &&
                    (
                        <Formik
                            initialValues={{
                                email: this.state.currentEmail,
                                newEmail: '',
                                newEmailConfirm: ''
                            }}
                            validateOnChange={true}
                            validateOnBlur={false}
                            validationSchema={UpdateEmailSchema}
                            validate={(values) => {
                                console.log('email values', values);
                                // Additional Validation (if any)
                                let error = {};
                                if (values.newEmail.toLowerCase() === this.state.currentEmail.toLowerCase()) {
                                    error.newEmail = 'There is no change in the email address.'
                                }

                                if (values.newEmailConfirm.toLowerCase() === this.state.currentEmail.toLowerCase()) {
                                    error.newEmailConfirm = 'There is no change in the email address.'
                                }

                                if (values.newEmail.toLowerCase() !== values.newEmailConfirm.toLowerCase()) {
                                    error.newEmailConfirm = 'Email does not match.'
                                }
                                return error;
                            }}
                            onSubmit={(values, actions) => {
                                console.log('onSubmit', values, actions);
                                this.setState({
                                    error: false,
                                    errorMessage: null,
                                    inVerifyOTPState: false,
                                    isVerifyPassword: true,
                                    success: false,
                                    newEmailConfirm: values.newEmailConfirm
                                });
                            }}
                            render={({
                                values,
                                errors,
                                status,
                                touched,
                                handleBlur,
                                handleChange,
                                handleSubmit,
                                isSubmitting,
                            }) => (
                                <Form style={{paddingBottom: 20, paddingTop: 20}}>
                                    <Grid columns={1}>
                                        <Grid.Column>
                                            <Field
                                                name="email"
                                                label="Current Email"
                                                component={FormsInputsEmail}
                                                secondaryLabel=""
                                                disabled={true}
                                            />
                                        </Grid.Column>
                                    </Grid>
                                    <Grid columns={2}>
                                        <Grid.Column>
                                            <Field
                                                name="newEmail"
                                                label="New Email"
                                                component={FormsInputsEmail}
                                                secondaryLabel=""
                                                disabled={false}
                                            />
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Field
                                                name="newEmailConfirm"
                                                label="Re-enter New Email"
                                                component={FormsInputsEmail}
                                                secondaryLabel=""
                                                disabled={false}
                                            />
                                        </Grid.Column>
                                        <Grid.Column width={16}>
                                            { this.renderFormSubmissionResult() }
                                        </Grid.Column>
                                        <Grid.Column width={16}>
                                            <Button
                                                loading={isSubmitting}
                                                type="submit"
                                                primary
                                                disabled={isSubmitting}
                                                fluid
                                                size="big"
                                            >
                                                Save
                                            </Button>
                                        </Grid.Column>
                                    </Grid>
                                </Form>
                            )}
                        />
                    )

                }
                {
                    this.state.isVerifyPassword
                    &&
                    (
                        <Formik
                            initialValues={{
                                password: '',
                            }}
                            validateOnChange={true}
                            validateOnBlur={false}
                            validate={(values, actions) => {
                                console.log('email values', values);
                                // Additional Validation (if any)
                                let error = {};
                                if (values.password == '') {
                                    error.password = 'Password is empty.'
                                
                                }
                                
                                return error;
                            }}
                            onSubmit={(values, actions) => {
                                console.log('onSubmit', values, actions);
                                this.props.verifyPasswordAction({id: this.props.user.uuid, password: values.password , accessToken: this.props.user.accessToken}, (result, error) => {
                                    console.log('done');
                                    console.log("result ", result)
                                    console.log("error ", error)
                                    if (error) {
                                        console.log('done-failed');
                                        actions.resetForm();
                                        actions.setSubmitting(false);
                                        this.setState({
                                            error: true,
                                            success: false,
                                            errorMessage: error.errorMessage
                                        });
                                    }
                                    if (result) {
                                        this.props.updateUserProfileGenerateChangeEmailOTP({data: {newEmail:this.state.newEmailConfirm}, accessToken: this.props.user.accessToken}, (result, error) => {
                                            console.log('done');
                                            if (error) {
                                                console.log('done-failed');
                                                actions.resetForm();
                                                actions.setSubmitting(false);
                                                this.setState({
                                                    error: true,
                                                    success: false,
                                                    errorMessage: error.errorMessage
                                                });
                                            }
                                            if (result) {
                                                console.log('done-success');
                                                actions.resetForm();
                                                actions.setSubmitting(false);
                                                this.setState({
                                                    error: false,
                                                    errorMessage: null,
                                                    inVerifyOTPState: true,
                                                    isVerifyPassword: false,
                                                    newEmailConfirm: this.state.newEmailConfirm
                                                });
                                            }
                                        });
                                    }
                                });
                            }}
                            render={({
                                values,
                                errors,
                                status,
                                touched,
                                handleBlur,
                                handleChange,
                                handleSubmit,
                                isSubmitting,
                            }) => (
                                <Form style={{paddingBottom: 20, paddingTop: 20}}>
                                    <Grid columns={2}>
                                        <Grid.Column>
                                            <div className="field">
                                              <label style={{marginBottom: 10}} htmlFor="password">Enter Password to proceed to change Email</label>
                                              <Input
                                                fluid // Make it take full width
                                                id="password"
                                                name="password"
                                                type={this.state.showPassword ? 'text' : 'password'}
                                                placeholder="Your password"
                                                value={values.password}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                icon={
                                                  <Icon
                                                    link
                                                    name={this.state.showPassword ? 'eye' : 'eye slash outline'}
                                                    onClick={()=> this.setState({showPassword : !this.state.showPassword})}
                                                  />
                                                }
                                              />
                                            </div>
                                            {touched.password && errors.password ? (
                                              <div style={{color: 'red'}}>
                                                {errors.password}
                                              </div>
                                            ) : null}
                                        </Grid.Column>
                                        
                                        <Grid.Column width={16}>
                                            { this.renderFormSubmissionResult() }
                                        </Grid.Column>
                                        <Grid.Column width={16}>
                                            <Button
                                                loading={isSubmitting}
                                                type="submit"
                                                primary
                                                disabled={isSubmitting}
                                                fluid
                                                size="big"
                                            >
                                                Save
                                            </Button>
                                        </Grid.Column>
                                    </Grid>
                                </Form>
                            )}
                        />
                    )
                }
                {
                    this.state.inVerifyOTPState
                    &&
                    <Formik
                        initialValues={{
                            otp: '',
                        }}
                        validateOnChange={false}
                        validateOnBlur={false}
                        validate={(values) => {
                            console.log('values', values);
                            // Additional Validation (if any)
                            let error = {};
                            if (values.otp.toString().length === 0) {
                                error.otp = 'OTP cannot be empty, please enter the OTP sent to your email address.'
                            }
                            return error;
                        }}
                        onSubmit={(values, actions) => {
                            console.log(values, actions);
                            this.props.updateUserProfileVerifyChangeEmailOTP({data: values, accessToken: this.props.user.accessToken}, (result, error) => {
                                console.log('done');
                                if (error) {
                                    console.log('done-failed');
                                    actions.resetForm();
                                    actions.setSubmitting(false);
                                    this.setState({error: true, success: false, errorMessage: error.errorMessage});
                                }
                                if (result) {
                                    console.log('done-success');
                                    actions.resetForm();
                                    actions.setSubmitting(false);
                                    this.setState({
                                        error: false,
                                        success: true,
                                        errorMessage: null
                                    });

                                    // call the update profile to update the email address
                                    this.props.updateUserProfileInformation({data: {'email': this.state.newEmailConfirm }, accessToken: this.props.user.accessToken}, (result, error) => {
                                        if (error) {
                                            console.log('done-failed');
                                            actions.resetForm();
                                            actions.setSubmitting(false);
                                            this.setState({error: true, success: false, errorMessage: error.errorMessage});
                                        }
                                        if (result) {
                                            console.log('done-success');
                                            actions.resetForm();
                                            actions.setSubmitting(false);
                                            this.setState({
                                                error: false,
                                                success: true,
                                                errorMessage: null,
                                                inVerifyOTPState: false,
                                                currentEmail: this.state.newEmailConfirm
                                            });
                                        }
                                    })
                                }
                            });
                        }}
                        render={({
                            values,
                            errors,
                            status,
                            touched,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                        }) => (
                            <Form style={{paddingBottom: 20, paddingTop: 20}}>
                                <Grid centered>
                                    <Grid.Column width={16}>
                                        <Message positive>
                                            <Message.Header>Check your Email!</Message.Header>
                                            <p>
                                                An OTP verification has been sent to { this.state.newEmailConfirm }
                                            </p>
                                        </Message>

                                    </Grid.Column>
                                    <Grid.Column width={16}>
                                        <Field
                                            name="otp"
                                            label="One Time Password (OTP)"
                                            component={FormsInputsNumber}
                                            secondaryLabel=""
                                        />
                                    </Grid.Column>

                                    <Grid.Column width={16}>
                                        { this.renderFormSubmissionResult() }
                                    </Grid.Column>

                                    <Grid.Column width={16}>
                                        <Button
                                            loading={isSubmitting}
                                            type="submit"
                                            primary
                                            disabled={isSubmitting}
                                            fluid
                                            size="big">
                                            Verify
                                        </Button>
                                    </Grid.Column>
                                </Grid>
                            </Form>
                        )}
                    />
                }
            </div>
        );
    }
}

export default FormsUpdateEmail;
